import createReactComponent from '../createReactComponent';
var Award = createReactComponent('Award', [['circle', {
  cx: '12',
  cy: '8',
  r: '7',
  key: '1ss14z'
}], ['polyline', {
  points: '8.21 13.89 7 23 12 20 17 23 15.79 13.88',
  key: '7r95pk'
}]]);
export default Award;